import { gql } from '@apollo/client';

import { assignmentFragment } from '../fragments';
import { AssignmentFormInput } from '../../types/form';
import { Assignment } from '../../types';

export interface UpdateAssignmentMutationVariables {
  courseId: string;
  assignmentId: string;
  input: AssignmentFormInput;
}

export interface UpdateAssignmentMutationResult {
  assignment: Assignment;
}

export const updateAssignmentMutation = gql`
  mutation UpdateAssignmentMutation($courseId: String!, $assignmentId: String!, $input: UpdateAssignmentMutationInput!) {
    assignment(courseId: $courseId, assignmentId: $assignmentId, input: $input)
      @rest(type: "Assignment", path: "courses/{args.courseId}/assignments/{args.assignmentId}", method: "PUT") {
      ...Assignment
    }
  }
  ${assignmentFragment}
`;
